import getPageSpecificValues from './GoogleAdTagConstants';

// eslint-disable-next-line import/prefer-default-export
export const isGAMExperimentEnabled = (brand, page) => {
  const { experiments } = getPageSpecificValues(page);
  const activeExperiment = experiments[brand];
  if (activeExperiment) {
    const { Cookie } = require('@common-vue/util/src/modules/cookie');
    const SeedCookie = Cookie.get('SEED') || '';
    return SeedCookie.indexOf(activeExperiment) > -1;
  }
  return true;
};

export const isBrandShowcaseExperimentEnabled = (brand) => {
  const experiment = brand === 'bcom' ? '2067-21' : '';
  if (!experiment) return true;
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return SeedCookie.indexOf(experiment) > -1;
};

export const isSimplificationOnExperimentEnabled = () => {
  const experiment = ['2054-21', '2054-22', '2054-23', '2054-24', '2054-25', '2054-26', '2054-27', '2054-34', '2054-35', '2054-36'];
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return experiment.some((expIds) => SeedCookie.includes(expIds));
};

export const isSimplificationWithV1ExpEnabled = () => {
  const experiment = '2054-22';
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return SeedCookie.indexOf(experiment) > -1;
};

export const isSponsoredBrandExperimentEnabled = () => {
  const experiment = '2161-21';
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return SeedCookie.indexOf(experiment) > -1;
};

export const isSimplificationNonBoldPercentageExpEnabled = () => {
  const experiment = ['2054-24', '2054-27', '2054-34', '2054-35', '2054-36'];
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return experiment.some((expIds) => SeedCookie.includes(expIds));
};

export const isSimplificationRemoveSaleExpEnabled = () => {
  const experiment = ['2054-26', '2054-27'];
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return experiment.some((expIds) => SeedCookie.includes(expIds));
};

export const isColorSwatchEnhancement = () => {
  const experiment = ['2483-22', '2483-21'];
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return experiment.some((expIds) => SeedCookie.includes(expIds));
};
export const isShowReviewCondensed = () => {
  const experiment = '2483-22';
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return SeedCookie.indexOf(experiment) > -1;
};
export const isRedesignCoreCarouselEnabled = () => {
  const experiment = '2483-22';
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return SeedCookie.indexOf(experiment) > -1;
};
export const isConsolidatedProductDescription = () => {
  const experiment = '2483-22';
  const { Cookie } = require('@common-vue/util/src/modules/cookie');
  const SeedCookie = Cookie.get('SEED') || '';
  return SeedCookie.indexOf(experiment) > -1;
};
